<template v-if="$temAcessoView('LICITACOES-01')">
    <solicitacao-form acao="INSERIR" @salvar="inserir($event)" @cancelar="cancelar" :erros="erros" :solicitacao="solicitacao"> </solicitacao-form>
</template>

<script>
import SolicitacaoForm from './SolicitacaoForm.vue';
import solicitacoesServices from '../services';
export default {
    components: {
        SolicitacaoForm,
    },

    data() {
        return {
            erros: [],
            solicitacao: null,
        };
    },

    methods: {
        inserir(solicitacaoDto) {
            this.$store.dispatch('addRequest');
            solicitacoesServices.inserir(solicitacaoDto).then((response) => {
                if (response && response.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Solicitações',
                        detail: 'Solicitação inserida com sucesso',
                        life: 3000,
                    });

                    const solicitacaoId = response.data;

                    this.$store.dispatch('setAtualizar', true);
                    this.$router.push({
                        name: 'Licitacoes_Solicitacoes_Detalhar',
                        params: {
                            id: solicitacaoId,
                        },
                    });
                } else {
                    const mensagemErro = this.formatarMensagemErro(response.errors);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro ao salvar a solicitação',
                        detail: mensagemErro,
                        life: 3000,
                    });
                    this.erros = response.erros;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        cancelar() {
            this.$router.push({
                name: 'Licitacoes_Solicitacoes',
            });
        },

        formatarMensagemErro(mensagemErro) {
            if (Array.isArray(mensagemErro)) {
                return mensagemErro.join(', ');
            }
            return mensagemErro;
        },
    },
};
</script>
